<template>
  <div id="create">
    <v-container fluid id="edit-profile-view" class="px-0">
      <v-form v-model="validEdit">
        <v-row justify="center" align="center">
          <v-col cols="12" md="4">
            <v-card>
              <v-toolbar color="warning" dark dense flat class="mb-1">
                <v-toolbar-title>
                  Basic details
                </v-toolbar-title>

                <v-spacer></v-spacer>
              </v-toolbar>
              <v-card-text>
                <v-container fluid>
                  <v-row>
                    <v-col cols="12">
                      <v-text-field
                        v-model="editedItem.usR_ID"
                        label="ID"
                        disabled
                      >
                      </v-text-field>
                    </v-col>
                    <v-col cols="12">
                      <v-text-field
                        v-model="editedItem.usR_FNAME"
                        label="First Name"
                      >
                      </v-text-field>
                    </v-col>
                    <v-col cols="12">
                      <v-text-field
                        v-model="editedItem.usR_MNAME"
                        label="Middle Name"
                      >
                      </v-text-field>
                    </v-col>
                    <v-col cols="12">
                      <v-text-field
                        v-model="editedItem.usR_LNAME"
                        label="Last Name"
                      >
                      </v-text-field>
                    </v-col>
                    <v-col cols="12">
                      <v-text-field
                        label="Date of Birth"
                        v-model="BIRTH_DT"
                      >
                      </v-text-field>
                    </v-col>
                    <v-col cols="12">
                      <v-select
                        :items="genders"
                        label="Gender"
                        item-text="text"
                        item-value="value"
                        v-model="editedItem.usR_GENDER"
                      >
                      </v-select>
                    </v-col>

                    <v-col cols="12">
                      <v-text-field
                        v-model="editedItem.usR_EMAIL"
                        label="Email ID"
                        :rules="reqRules"
                        :counter="50"
                        maxlength="50"
                      >
                      </v-text-field>
                    </v-col>
                    <v-col cols="12">
                      <v-text-field
                        v-model="editedItem.usR_CUR_CELL_NO"
                        label="Current mobile No"
                        :rules="reqRules"
                        :counter="15"
                        maxlength="15"
                      >
                      </v-text-field>
                    </v-col>
                  </v-row>
                </v-container>
              </v-card-text>
            </v-card>
          </v-col>
          <v-col cols="12" >
            <v-card class="mx-3">
              <v-toolbar color="warning" dark dense flat class="mb-1">
                <v-toolbar-title>
                  Address details
                </v-toolbar-title>

                <v-spacer></v-spacer>
              </v-toolbar>
              <v-card-text>
                <v-container fluid>
                  <v-row>
                    <v-col cols="12" md="3">
                      <v-text-field
                        v-model="editedItem.usR_CUR_ADD1"
                        label="Current Address1"
                        :rules="reqRules"
                        :counter="30"
                        maxlength="30"
                      >
                      </v-text-field>
                    </v-col>
                    <v-col cols="12" md="3">
                      <v-text-field
                        v-model="editedItem.usR_CUR_ADD2"
                        label="Current Address2"
                        :counter="30"
                        maxlength="30"
                      >
                      </v-text-field>
                    </v-col>
                    <v-col cols="12" md="3">
                      <v-text-field
                        v-model="editedItem.usR_CUR_ADD3"
                        label="Current Address3"
                        :counter="30"
                        maxlength="30"
                      >
                      </v-text-field>
                    </v-col>
                    <v-col cols="12" md="3">
                      <v-text-field
                        v-model="editedItem.usR_CUR_PINCODE"
                        label="Current Pincode"
                        :rules="reqRules"
                        :counter="20"
                        maxlength="20"
                      >
                      </v-text-field>
                    </v-col>
                  </v-row>
                  <v-row dense>
                    <v-col justify="end" align="end">
                      <v-btn color="blue darken-1" text @click="editItem">
                        Cancel
                      </v-btn>
                      <v-btn
                        color="blue darken-1"
                        :loading="saveLoading"
                        text
                        @click="saveProfile"
                        :disabled="!validEdit"
                      >
                        Save
                      </v-btn>
                    </v-col>
                  </v-row>
                </v-container>
              </v-card-text>
            </v-card>
          </v-col>
        </v-row>
      </v-form>
    </v-container>
  </div>
</template>

<script>
import axios from "axios";
import { get } from "vuex-pathify";

import { showSnackbar } from "../util/globalActions";
import moment from "moment";

export default {
  name: "ProfessorProfile",

  data: () => ({
    reqRules: [(v) => !!v || "Field is required"],
    validEdit: false,
    permission: {
      isAdd: false,
      isEdit: false,
      isDelete: false,
      isDownload: false,
    },
    genders: [
      {
        text: "Male",
        value: "M",
      },
      {
        text: "Female",
        value: "F",
      },
    ],
    saveLoading: false,
    BIRTH_DT: "",
    message: "",
    snackbar: false,
    length: 4,
    tab: null,
    editedItem: {
      usR_ID: "",
      usR_FNAME: "",
      usR_MNAME: "",
      usR_LNAME: "",
      usR_TYPE: "",
      usR_BIRTH_DT: null,
      usR_GENDER: "",
      usR_EMAIL: "",
      usR_CUR_CELL_NO: "",
      usR_CUR_ADD1: "",
      usR_CUR_ADD2: "",
      usR_CUR_ADD3: "",
      usR_CUR_PINCODE: "",
    },
  }),
  created() {},
  mounted() {
    const self = this;

    self.editItem();
  },
  computed: {
    apiUrl: get("app/apiUrl"),
  },
  watch: {},
  methods: {
    editItem() {
      const self = this;

      axios({
        url: self.apiUrl + "api/Users/Profile",
        method: "GET",
      })
        .then(function(res) {
          if (res.data.status === "OK") {
            console.log(res.data.data);
            self.editedItem = res.data.data;
            self.BIRTH_DT = moment(new Date(res.data.data.usR_BIRTH_DT)).format(
              "DD-MMM-YYYY"
            );
          } else {
            showSnackbar({ message: res.data.message });
          }
        })
        .catch(function(err) {
          self.message = err.status;

          showSnackbar({ message: "Data not found!" });
        });
    },

    saveProfile() {
      const self = this;

      self.saveLoading = true;
      axios({
        url: self.apiUrl + "api/Users/updateprofile",
        data: self.editedItem,
        method: "POST",
        responseType: "json",
      })
        .then(function(res) {
          self.saveLoading = false;
          if (res.data.status === "OK")
            showSnackbar({
              message: res.data.message,
              color: "secondary",
            });
          else
            showSnackbar({
              message: res.data.message,
            });
        })
        .catch(function(err) {
          console.log(err);
          self.saveLoading = false;
          self.message = err.status;

          showSnackbar({ message: "Error while update profile!" });
        });
    },
  },
  beforeDestroy() {},
};
</script>
